/* eslint-disable react/jsx-no-target-blank */
import { IAdFoxBannerContext } from '@cian/adfox/build/react';
import * as React from 'react';

import * as styles from './index.css';

export interface ITgbBannerProps {
  context: IAdFoxBannerContext;
}

export class TgbBanner extends React.PureComponent<ITgbBannerProps, {}> {
  public render() {
    const { context } = this.props;

    return (
      <a href={context.url} target="_blank" rel="nofollow noopener" className={styles['container']}>
        {context.label && <div className={styles['label']}>{context.label}</div>}
        <div className={styles['image']}>
          <img src={context.bgImageUrl} alt={context.title} />
        </div>
        <div className={styles['aside']}>
          <h4 className={styles['title']}>{context.title}</h4>
          <p className={styles['text']}>{context.description}</p>
          {context.phone && <div className={styles['phone']}>{context.phone}</div>}
        </div>
        {context.note && <div className={styles['note']}>{context.note}</div>}
      </a>
    );
  }
}
